const useBoundaryCategoryChart = ({ options }: any) => {
  return {
    ...options,
    xAxis: {
      ...options.xAxis,
      boundaryGap: false,
      data: Array.isArray(options.xAxis.data)
        ? ['', ...(options.xAxis.data as any[]), '']
        : options.xAxis.data || [],
    },
    series: options.series.map((serie: any) => {
      return {
        ...serie,
        data: Array.isArray(options.xAxis.data)
          ? ['', ...(serie.data as any[]), '']
          : serie.data || [],
      };
    }),
  };
};

export default useBoundaryCategoryChart;
